/**
 * Site feature flags. Flip a value to true to launch a gated feature.
 */
export const FEATURES = {
  club: true,
} as const;
